import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { NAV } from "@/content/landing";

export default function LandingNav() {
  return (
    <header className="landing-nav">
      <Link to="/" className="landing-nav-brand" aria-label="Perform, accueil"><Logo /></Link>
      <nav className="landing-nav-links" aria-label="Navigation principale">
        {NAV.links.map(l => <Link key={l.to} to={l.to}>{l.label}</Link>)}
      </nav>
      <div className="landing-nav-actions">
        <Link to="/auth" className="landing-link" data-testid="landing-nav-login">{NAV.login}</Link>
        <Link to="/auth" state={{ mode: "register" }} className="button button-dark" data-testid="landing-nav-start">{NAV.start}</Link>
      </div>
    </header>
  );
}
